var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",attrs:{"title":"返回首页"},on:{"click":_vm.toEBCHome}},[_c('span',{staticClass:"iconfont iconhome1",class:{'black': _vm.color===1}})])
}
var staticRenderFns = []

export { render, staticRenderFns }